import React from 'react';

type Props = {}

const TopBarIcons = (props: Props) => {
  return (
    <></>
  )
}

export default TopBarIcons;